import { atom } from "jotai";

export const atomOpenMenu = atom<string | null>(null);
